import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

const defaultBaseColor = '#eee'
const duration = 1.2
const defaultHighlightColor = '#f5f5f5'

const skeletonKeyframes = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`

export const SkeletonStyle = styled.span`
	background-color: ${defaultBaseColor};
	background-image: linear-gradient(90deg, ${defaultBaseColor}, ${defaultHighlightColor}, ${defaultBaseColor});
	background-size: 200px 100%;
	background-repeat: no-repeat;
	border-radius: 4px;
	display: inline-block;
	line-height: 1;
	width: 100%;
	animation: ${skeletonKeyframes} ${duration}s ease-in-out infinite;
`
